import { Users, Leaf, Eye, Store, Utensils, Building2, Home, Fuel, Network, ShoppingBag, ShoppingBasket, BedDouble } from "lucide-react";
import { Kicker, MaskLines, Rise, SlideShell } from "@/deck/ui";

const impacts = [
  { icon: Users, title: "Community-based", text: "Tenants, BM and neighbours on one secure network." },
  { icon: Leaf, title: "Energy efficiency", text: "Prepaid, per-unit self-control — use within budget." },
  { icon: Eye, title: "Payment transparency", text: "Both sides see the same kWh and the same rupiah." },
  { icon: Store, title: "Digital BM & UMKM", text: "Kasir digital + QRIS for kiosks around the area." },
];

const segments = [
  { icon: Utensils, label: "Canteens & culinary centers" },
  { icon: Building2, label: "Apartments" },
  { icon: Home, label: "Rental houses" },
  { icon: Fuel, label: "Rest areas" },
  { icon: Network, label: "Private-grid housing" },
  { icon: ShoppingBag, label: "Malls, kiosks & tenants" },
  { icon: ShoppingBasket, label: "Traditional & modern markets" },
  { icon: BedDouble, label: "Dormitories" },
];

export default function Impact() {
  return (
    <SlideShell testId="impact-slide">
      <div className="grid flex-1 gap-5 lg:min-h-0 lg:grid-cols-12">
        <div className="flex flex-col lg:col-span-5">
          <Rise><Kicker index="05">Social impact</Kicker></Rise>
          <MaskLines lines={["Power to the", "community."]} accentIndex={1} className="mt-4 text-4xl font-extrabold leading-[0.95] tracking-[-0.035em] sm:text-5xl lg:text-6xl" />
          <Rise delay={0.3} className="relative mt-6 min-h-[220px] flex-1 overflow-hidden rounded-3xl border border-white/10" data-testid="impact-photo">
            <img src="/assets/umkm.jpg" alt="UMKM food stall vendor accepting QRIS payment" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07080b] via-transparent to-transparent" />
            <p className="absolute bottom-4 left-5 right-5 font-display text-lg font-semibold leading-snug text-zinc-50">Every kiosk becomes a digital business.</p>
          </Rise>
        </div>
        <div className="flex flex-col gap-4 lg:col-span-7">
          <div className="grid gap-3 sm:grid-cols-2 lg:flex-1">
            {impacts.map((m, i) => (
              <Rise key={m.title} delay={0.35 + i * 0.08} className="group flex flex-col justify-between rounded-3xl border border-white/10 bg-[var(--panel)] p-5 transition-colors duration-500 hover:border-dash/50" data-testid={`impact-card-${i + 1}`}>
                <m.icon size={26} className="text-[var(--dash)] transition-transform duration-500 group-hover:-translate-y-1" />
                <div className="mt-6">
                  <h3 className="font-display text-xl font-semibold tracking-tight text-zinc-50 lg:text-2xl">{m.title}</h3>
                  <p className="mt-1 text-sm text-zinc-300">{m.text}</p>
                </div>
              </Rise>
            ))}
          </div>
          <Rise delay={0.7} className="rounded-3xl border border-white/10 bg-[var(--panel)] p-5" data-testid="impact-segments">
            <div className="flex items-baseline justify-between gap-3">
              <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-zinc-300">Already powering 8 segments</p>
              <p className="font-mono-d text-[11px] text-zinc-500">Source: powermanager.my.id</p>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-4">
              {segments.map((s) => (
                <div key={s.label} className="flex items-center gap-2.5">
                  <s.icon size={16} className="shrink-0 text-zinc-400" />
                  <span className="text-xs leading-tight text-zinc-200">{s.label}</span>
                </div>
              ))}
            </div>
          </Rise>
        </div>
      </div>
    </SlideShell>
  );
}
